<script lang="ts" setup>
const route = useRoute()

const slug = computed(() => {
  return Array.isArray(route.params.slug) ? route.params.slug[0] : route.params.slug
})
</script>

<template>
  <DocsPageRender
    v-if="slug"
    :slug="slug"
  />
</template>
